<template>
  <div>
    <div class="row">
      <div class="col-sm-4 mb-2">
        <button
          class="btn btn-info btn-sm"
          @click="showModal('create')"
        >
          {{ $t('manage-question.create') }}
        </button>
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-center mb-2">
        <small>{{ $t('pagination.show') }}</small>
        <select
          v-model="pagination.PageSize"
          class="form-control form-control-sm w-auto mx-2"
        >
          <option
            v-for="(size, s) in pageSizes"
            :key="s"
            :value="size"
          >
            {{ size }}
          </option>
        </select>
        <small>{{ $t('pagination.entries') }}</small>
      </div>
    </div>

    <data-table
      class="my-3"
      :fields="getFields($i18n.locale)"
      :data="criteria"
    >
      <template #action="{ rowData }">
        <div class="d-flex justify-content-between">
          <a
            v-if="permission.permissions.includes('edit')"
            class="text-info mr-2"
            :title="rowData.id"
            @click="showModal('update', rowData.id)"
          >
            <img
              src="@/assets/icon/edit.png"
              alt="edit"
            >
          </a>
          <a
            v-if="permission.permissions.includes('delete') && !rowData.isReserved"
            class="text-info mr-2"
            :title="rowData.id"
            @click="showModal('delete', rowData.id)"
          >
            <img
              src="@/assets/icon/delete.png"
              alt="delete"
            >
          </a>
        </div>
      </template>
    </data-table>

    <div class="d-flex flex-wrap justify-content-center justify-content-sm-between">
      <div class="mb-2">
        <pagination-info
          :page="criteria.currentPage"
          :page-size="criteria.pageSize"
          :shown="criteria.data.length"
          :total="criteria.totalData"
        />
      </div>

      <pagination
        ref="pagination"
        class="mb-2"
        @change="onPageChange"
      />
    </div>

    <update-criteria
      v-if="modal.update"
      :id="modal.id"
      @close="closeModal"
    />

    <create-criteria
      v-if="modal.create"
      @close="closeModal"
    />

    <delete-criteria
      v-if="modal.delete"
      :id="modal.id"
      @close="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import { PAGE_SIZES } from '@/fixtures'
import DataTable from '@/components/DataTable'
import PaginationInfo from '@/components/PaginationInfo'
import Pagination from '@/components/Pagination'
import UpdateCriteria from '@/views/ManageQuestion/Criteria/Update'
import CreateCriteria from '@/views/ManageQuestion/Criteria/Create'
import DeleteCriteria from '@/views/ManageQuestion/Criteria/Delete'

export default {
  components: {
    DataTable,
    PaginationInfo,
    Pagination,
    UpdateCriteria,
    CreateCriteria,
    DeleteCriteria
  },

  data: () => ({
    pagination: {
      Page: 1,
      PageSize: 10
    },
    criteria: {
      data: []
    },
    modal: {
      update: false,
      create: false,
      delete: false
    }
  }),

  computed: {
    pageSizes: () => PAGE_SIZES
  },

  watch: {
    '$i18n.locale' () {
      this.getFields(this.$i18n.locale)
    }
  },

  created () {
    const dataLoc = JSON.parse(localStorage.getItem('profile'))
    const index = dataLoc.role.permissions.findIndex(element => element.category === 'criteria')
    this.permission = dataLoc.role.permissions[index]
    this.fetch()
  },

  methods: {
    onPageChange (page) {
      this.pagination.Page = page
      this.fetch()
    },
    getFields (locale) {
      if (locale === 'en') {
        return [
          { name: 'action', title: 'Action', dataClass: '__action' },
          { name: 'riskLevel', title: 'Risk Level', dataClass: '__risk' },
          { name: 'pattern', title: 'Criteria Pattern', dataClass: '__pattern' },
          { name: 'value', title: 'Criteria Level', dataClass: '__level' }
        ]
      }
      if (locale === 'id') {
        return [
          { name: 'action', title: 'Tindakan', dataClass: '__action' },
          { name: 'riskLevel', title: 'Tingkat Resiko', dataClass: '__risk' },
          { name: 'pattern', title: 'Pola Kriteria', dataClass: '__pattern' },
          { name: 'value', title: 'Level Kriteria', dataClass: '__level' }
        ]
      }
    },
    async fetch () {
      const { data } = await Api.criteria.list({
        ...this.pagination
      })
      this.criteria = data
      this.$refs.pagination.setPaginationData({
        total: data.totalData,
        per_page: data.pageSize,
        current_page: data.currentPage,
        last_page: data.totalPage
      })
    },
    showModal (modalName, id) {
      this.modal.id = id
      this.modal[modalName] = true
    },
    closeModal (modalName) {
      this.modal[modalName] = false
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.__action) { min-width: 70px; max-width: 70px; }
::v-deep(.__risk) { min-width: 300px; max-width: 300px; }
::v-deep(.__pattern) { min-width: 300px; max-width: 300px; }
::v-deep(.__level) { min-width: 100px; max-width: 100px; }
</style>
